<template>
  <div class="hotel-edit-accordion-7">
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Políticas e Restrições das tarifas
      <PmwInfoTooltip width="235px">
        <template #content>
          Políticas e condições restritas a esta tarifa, em
          {{
            tabs.find((item) => item.dataAttribute.includes(language)).language
          }}. Será demonstrado caso não seja informado a política dentro da
          flutuação
        </template>
      </PmwInfoTooltip>
    </PmwHeading>

    <PmwParagraph class="form--info" size="paragraph-40">
      Defina as políticas e restrições que serão exibidas como padrão para as
      todas as condições. <br />
      Na tela de configuração tarifária é possível configurar políticas
      específicas para cada tarifa.
    </PmwParagraph>

    <div class="form--row">
      <!-- DESCRIÇÃO -->
      <Textarea
        :value="policyDescription"
        :counter="true"
        :maxlength="500"
        :row="7"
        :hasLanguages="true"
        :language="language"
        label="Descrição das políticas"
        placeholder="Insira a política."
        class="form--input__policyDescription"
        @changeLanguage="language = $event"
        @input="updatePolicyDescription"
      />

      <div class="flex-grow-1">
        <!-- ITENS INCLUSOS EM TARIFAS -->
        <PmwFormSelect
          :value="tariff"
          :options="itemsIncludedRate"
          :search="true"
          :infoIcon="true"
          :multiple="true"
          tooltipMinWidth="200"
          infoText="Selecione o que a tarifa inclui. Será utilizado caso não tiver nada selecionado na flutuação."
          label="Itens inclusos em tarifas"
          placeholder="Selecione itens"
          class="form--input form--input__policySelect"
          @input="$emit('changeTariff', $event)"
        />

        <!-- ITENS DE DESTAQUE -->
        <PmwFormSelect
          v-if="tariff && tariff.length > 3"
          :value="emphasis"
          :options="formattedPolicyTariffEmphasis"
          :search="true"
          :infoIcon="true"
          :multiple="true"
          :toggleAll="false"
          tooltipMinWidth="154"
          infoText="Selecione os três itens que serão destaque."
          label="Selecione três itens para destaque"
          placeholder="Selecione itens em destaque"
          class="form--input form--input__policySelect"
          @input="$emit('changeEmphasis', $event)"
        />
      </div>
    </div>

    <div v-if="hasPoints">
      <PmwHeading
        size="paragraph-80"
        weight="weight-light"
        class="form--title form--title__with-subtitle"
      >
        Políticas e Restrições da Tarifa de Pontos
      </PmwHeading>

      <PmwParagraph class="form--info" size="paragraph-40">
        Defina as políticas e restrições que serão exibidas para a condição
        tarifária de Pontos.
      </PmwParagraph>

      <div class="form--row">
        <!-- DESCRIÇÃO -->
        <Textarea
          :value="pointsTextDescription"
          :counter="true"
          :maxlength="1500"
          :row="7"
          :hasLanguages="true"
          :language="languagePoints"
          label="Descrição da política de pontos"
          placeholder="Insira a política."
          class="form--input__policyDescription"
          @changeLanguage="languagePoints = $event"
          @input="updatePointsDescription"
        />
      </div>
    </div>

    <!-- CÓDIGO DE DEFESA DO CONSUMIDOR -->
    <div v-if="hasCdcEnabled" class="cdc-row">
      <PmwHeading
        size="paragraph-80"
        weight="weight-light"
        class="form--title form--title__with-subtitle"
      >
        Código de Defesa do Consumidor
      </PmwHeading>

      <PmwParagraph class="form--info" size="paragraph-40">
        Defina as políticas e restrições que serão exibidas para a condição
        tarifária de acordo com o Código de Defesa do Consumidor.
      </PmwParagraph>

      <div class="form--row">
        <!-- DESCRIÇÃO -->
        <Textarea
          :value="cdcTextDescription"
          :counter="true"
          :maxlength="2000"
          :row="7"
          :hasLanguages="true"
          :language="languageCdc"
          label="Descrição do código de defesa do consumidor"
          placeholder="Insira a política."
          class="form--input__policyDescription"
          @changeLanguage="languageCdc = $event"
          @input="updateCdcDescription"
        />
      </div>
    </div>

    <!-- TÍTULO -->
    <PmwHeading
      size="paragraph-80"
      weight="weight-light"
      class="form--title form--title__with-subtitle"
    >
      Políticas gerais do hotel
    </PmwHeading>

    <PmwParagraph class="form--info" size="paragraph-40">
      Defina políticas gerais, por categoria, que serão exibidas ao hóspede na
      página do hotel.
    </PmwParagraph>

    <!-- POLÍCIAS GERAIS -->
    <Tabs v-for="(item, i) in generalPolicy" :key="i" class="tabs">
      <template
        v-for="(tab, index) in tabs"
        v-slot:[`tab-title-${index}`]="{ title, tabObj }"
      >
        <span :key="tab.title" class="tabs--title">
          <img :src="tabObj.extraData.flag" />
          {{ title }}
        </span>
      </template>

      <!-- BOTÃO PARA REMOVER -->
      <span class="tabs--button-remove" @click="removeGeneralPolicy(i)"
        >Excluir</span
      >

      <Tab
        v-for="tab in tabs"
        :extraData="tab"
        :key="tab.title"
        :title="tab.title"
        class="tabs--item"
      >
        <div>
          <!-- TÍTULO DA POLÍTICA -->
          <PmwFormInput
            :value="generalPolicyTitle(item, tab.dataAttribute)"
            label="Título da política"
            placeholder=""
            class="form--input__generalPolicyTitle"
            @input="
              handleGeneralPolicyInput(
                $event,
                item,
                'titulo',
                tab.dataAttribute
              )
            "
          />

          <!-- DESCRIÇÃO -->
          <Textarea
            :value="generalPolicyDescription(item, tab.dataAttribute)"
            :counter="true"
            :maxlength="1500"
            label="Descrição"
            placeholder=""
            class="form--input__generalPolicyDescription"
            @input="
              handleGeneralPolicyInput(
                $event,
                item,
                'descricao',
                tab.dataAttribute
              )
            "
          />
        </div>
      </Tab>
    </Tabs>

    <!-- ADICIONAR NOVA POLÍTICA GERAL -->
    <PmwButton
      :hasIcon="true"
      layout="outline"
      variation="blue-100"
      class="button__outline form--button"
      @click="addGeneralPolicy()"
    >
      Adicionar política
    </PmwButton>
  </div>
</template>

<script>
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'
import Tab from '@/components/_base/patterns/Tab'
import Tabs from '@/components/_base/patterns/Tabs'

/** Bandeiras de idiomas */
import en from '@/assets/images/en-flag.png'
import es from '@/assets/images/es-flag.png'
import pt from '@/assets/images/ptbr-flag.png'

export default {
  name: 'TariffPolicies',

  components: {
    Textarea,
    PmwHeading,
    PmwParagraph,
    PmwFormInput,
    PmwFormSelect,
    PmwInfoTooltip,
    Tabs,
    Tab,
    PmwButton
  },

  props: {
    /** Itens inclusos nas tarifas */
    tariff: {
      type: Array,
      default: () => []
    },

    /** Itens para destaque */
    emphasis: {
      type: Array,
      default: () => []
    },

    description: {
      type: Array,
      default: () => []
    },

    pointsDescription: {
      type: Array,
      default: () => []
    },

    cdcDescription: {
      type: Array,
      default: () => []
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    },

    /** Lista de itens inclusos na tarifa */
    itemsIncludedRate: {
      type: Array,
      default: () => []
    },

    /** Políticas gerais */
    generalPolicy: {
      type: Array,
      default: () => []
    },

    hasPoints: {
      type: Boolean,
      default: false
    },

    /** Se está com o código de defesa do consumidor habilitado */
    hasCdcEnabled: Boolean
  },

  data() {
    return {
      /** Linguagem selecionada */
      language: 'pt',
      languagePoints: 'pt',
      languageCdc: 'pt',

      /** Abas com os idiomas */
      tabs: [
        {
          title: 'PT',
          dataAttribute: 'pt-BR',
          label: 'Português',
          language: 'português',
          flag: pt,
          position: 0
        },
        {
          title: 'EN',
          dataAttribute: 'en-US',
          label: 'English',
          language: 'inglês',
          flag: en,
          position: 1
        },
        {
          title: 'ES',
          dataAttribute: 'es-ES',
          label: 'Español',
          language: 'espanhol',
          flag: es,
          position: 2
        }
      ]
    }
  },

  computed: {
    /** Formatar a descrição */
    policyDescription() {
      return (
        this.description.find((item) => item.idioma.includes(this.language))
          ?.descricao || []
      )
    },

    pointsTextDescription() {
      return (
        this.pointsDescription?.find((item) =>
          item.idioma.includes(this.languagePoints)
        )?.descricao || []
      )
    },

    /** Retorna a descrição do código de defesa do consumidor de acordo com o idioma selecionado */
    cdcTextDescription() {
      return (
        this.cdcDescription?.find((item) =>
          item.idioma.includes(this.languageCdc)
        )?.descricao || []
      )
    },

    /** Opções de itens inclusos na tarifa, para serem selecionados os três principais */
    formattedPolicyTariffEmphasis() {
      return this.emphasis.length < 3 ? this.tariff : this.emphasis
    },

    /** Ordena a lista de politicas gerais pelo parametro `ordem` quando existir */
    sortedGeneralPolicy() {
      return [...this.generalPolicy].sort((a, b) => a?.ordem - b?.ordem)
    },

    generalPolicyTitle() {
      return (item, tabValue) =>
        item.textos?.find((text) => text.idioma === tabValue)?.titulo
    },

    generalPolicyDescription() {
      return (item, tabValue) =>
        item.textos?.find((text) => text.idioma === tabValue)?.descricao
    }
  },

  watch: {
    generalPolicy: {
      handler: function() {
        this.$emit('changeGeneralPolicy', this.generalPolicy)
      },
      deep: true
    },
    /** Detectar se houver uma mudança nos itens selecionados */
    tariff: {
      handler: function() {
        const emphasisList = []
        for (let i = 0; i < this.emphasis.length; i++) {
          if (this.tariff.includes(this.emphasis[i])) {
            emphasisList.push(this.emphasis[i])
          }
        }
        /** Atualizar a lista de itens em destaques marcados */
        this.$emit('changeEmphasis', emphasisList)
        /** Se for selecionado menos de três itens, limpar os itens em destaque */
        if (this.formattedPolicyTariffEmphasis.length < 4)
          this.$emit('changeEmphasis', [])
      },
      deep: true
    }
  },

  methods: {
    /** Atualizar o campo de textarea das políticas do hotel
     * @param {String} value: valor do textarea
     */
    updatePolicyDescription(value) {
      const foundedItem = this.description.find((item) =>
        item.idioma.includes(this.language)
      )
      if (foundedItem) {
        foundedItem.descricao = value
      }
      this.$emit('changeDescription', this.description)
    },

    /** Atualizar o campo de textarea das políticas do hotel
     * @param {String} value: valor do textarea
     */
    updatePointsDescription(value) {
      const foundedItem = this.pointsDescription?.find((item) =>
        item.idioma.includes(this.languagePoints)
      )
      if (foundedItem) {
        foundedItem.descricao = value
      }
      this.$emit('changePointsDescription', this.pointsDescription)
    },

    /** Atualizar o campo de textarea das políticas do hotel
     * @param {String} value: valor do textarea
     */
    updateCdcDescription(value) {
      const foundedItem = this.cdcDescription?.find((item) =>
        item.idioma.includes(this.languageCdc)
      )
      if (foundedItem) {
        foundedItem.descricao = value
      }
      this.$emit('changeCdcDescription', this.cdcDescription)
    },

    /** Adicionar política geral */
    addGeneralPolicy() {
      const newItemOrder = this.generalPolicy.length
        ? Math.max(...this.generalPolicy.flatMap((item) => item.ordem)) + 1
        : 0

      return this.generalPolicy.push({
        ordem: newItemOrder,
        textos: [
          {
            idioma: 'es-ES',
            titulo: '',
            descricao: ''
          },
          {
            idioma: 'en-US',
            titulo: '',
            descricao: ''
          },
          {
            idioma: 'pt-BR',
            titulo: '',
            descricao: ''
          }
        ]
      })
    },

    /** Remover política geral
     * @param {Number} index: Posição da política que será removida
     */
    removeGeneralPolicy(index) {
      return this.generalPolicy.splice(index, 1)
    },

    /**
     * Atualiza o objeto das políticas com o valor do input
     * @param {string} $event Valor do input atualizado
     * @param {object} item objeto do item que está sendo manipulado
     * @param {string} paramKey se é o parametro de titulo ou descricao
     * @param {number} tabValue Valor da tab de idioma
     */
    handleGeneralPolicyInput($event, item, paramKey, tabValue) {
      const obj = item.textos?.find((text) => text.idioma === tabValue)
      obj[paramKey] = $event
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }
    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.pmw-info-tooltip {
  ::v-deep {
    .pmw-custom-tooltip {
      display: flex;
      gap: 5px;
      color: $pmw-gray-dark;
      font-size: font-size('size-small');
      line-height: 18px;
    }
  }
  .pmw-custom-tooltip--arrow {
    display: none;
  }
}

.pmw-textarea {
  ::v-deep {
    .pmw-textarea--label {
      margin-left: 0px;
    }
    .pmw-textarea--field {
      line-height: 21px;
    }
  }
}

.form {
  &--input {
    max-width: 176px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__policyDescription {
      max-width: 480px;
    }

    &__policySelect {
      max-width: 260px;
      margin-bottom: 30px;
      display: block;

      &:last-child {
        margin-bottom: 0px;
      }
    }

    &__generalPolicyTitle {
      max-width: 424px;
      margin-bottom: 50px;
    }

    &__generalPolicyDescription {
      max-width: 697px;
    }
  }

  &--info {
    line-height: 18px;
    margin-bottom: 32px;
    color: $pmw-gray-dark;
  }

  &--row {
    display: flex;
    align-items: flex-start;
    flex-wrap: unset;
    gap: 66px;
    margin-bottom: 66px;
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 8px;
    position: relative;
  }

  &--button {
    width: auto;
  }
}

.button {
  &__outline ::v-deep {
    .pmw-button--icon__left {
      gap: 10px;
    }
  }
}

.tabs {
  margin-bottom: 24px;
  border: 1px solid pmw-colors('grey-20');
  position: relative;

  &--title {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &--button-remove {
    color: pmw-colors('error-100');
    font-weight: font-weight('weight-medium');
    position: absolute;
    top: 0px;
    right: 0px;
    margin: 17px 16px 0px 0px;
    cursor: pointer;
  }

  ::v-deep {
    .tabs--head {
      margin: 0px;
    }
    .tabs--content {
      padding: 32px 29px;
    }
    .tab {
      padding: 12px 20px 10px 15px;
    }
  }
}
</style>
